import { render, staticRenderFns } from "./city-box.vue?vue&type=template&id=6f5cd845&"
import script from "./city-box.vue?vue&type=script&lang=js&"
export * from "./city-box.vue?vue&type=script&lang=js&"
import style0 from "./city-box.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports